import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/dvpetrov/Workspace/dxfeed-js-api-poc/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h1>
    <h2 {...{
      "id": "import-package"
    }}>{`Import package`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import DXClient from '@dxfeed/widgets-api'
`}</code></pre>
    <h2 {...{
      "id": "configure--create-connection"
    }}>{`Configure & Create connection`}</h2>
    <p>{`Create instance of DXClient and set web socket address and open connection.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import DXClient from '@dxfeed/widgets-api'

const client = new DXClient('wss://CLIENT_NAME.dxfeed.com/api/rsocket')
`}</code></pre>
    <h2 {...{
      "id": "configure--create-subscription"
    }}>{`Configure & Create subscription`}</h2>
    <p>{`You should specify the record and the requested symbols.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { QuoteSubscription } from '@dxfeed/widgets-api/records/Quote'

const subscription = await client.subscribe(
  new QuoteSubscription(
    ['AAPL'] /* symbols */
  )
)
`}</code></pre>
    <p>{`The full list of records can be found here:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { /* Subscription */ } from '@dxfeed/widgets-api/records/*'
`}</code></pre>
    <p>{`You can specify fields you want to request for each type of event. This can be achieved by passing a list of them as a second parameter of `}<inlineCode parentName="p">{`Subscription`}</inlineCode>{`. If no value provided (i.e. parameter is `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`), a default set of fields will be requested. List of event types with all available fields for each of them can be found `}<a parentName="p" {...{
        "href": "https://studio.asyncapi.com/?url=https://dxfeed-demo.s3.amazonaws.com/dxFeed-WebApi-alpha.yaml"
      }}>{`here`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`client.subscribe(
  new QuoteSubscription(
    symbols,
    ['eventSymbol', 'bidPrice'] /* fields */
  )
)
`}</code></pre>
    <p>{`NOTE: `}<inlineCode parentName="p">{`eventSymbol`}</inlineCode>{` field is mandatory for all types of events. If you want to request a subset of fields, you must include `}<inlineCode parentName="p">{`eventSymbol`}</inlineCode>{`.`}</p>
    <p>{`Some of the events may may be requested using timed subscription (i.e. with inclusion of historical data). These are: `}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`Candle`}</inlineCode>{` `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`Greeks`}</inlineCode>{` `}</li>
      <li parentName="ul"><inlineCode parentName="li">{`TheoPrice`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`TimeAndSale`}</inlineCode></li>
      <li parentName="ul"><inlineCode parentName="li">{`Underlying`}</inlineCode></li>
    </ul>
    <p>{`For timed subscription you should also provide time to start subscription from.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`client.subscribe(
  new CandleSubscription(
    symbols,
    fields,
    1500000000000 /* from time */
  )
)
`}</code></pre>
    <p>{`NOTE: for timed events requested with custom selection of fields, an `}<inlineCode parentName="p">{`eventFlags`}</inlineCode>{` field is also mandatory.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`/* Timed subscription, requesting a default set of fields */

client.subscribe(
  new CandleSubscription(
    symbols,
    undefined,
    1500000000000
  )
)

/* Timed subscription, requesting a custom set of fields */

client.subscribe(
  new CandleSubscription(
    symbols,
    ['eventSymbol', 'eventFlags', 'high', 'low'],
    1500000000000
  )
)
`}</code></pre>
    <h2 {...{
      "id": "change-symbols-in-subscription"
    }}>{`Change symbols in subscription`}</h2>
    <h3 {...{
      "id": "add-symbols"
    }}>{`Add symbols`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`subscription.addSymbols(['MSFT'])
`}</code></pre>
    <h3 {...{
      "id": "remove-symbols"
    }}>{`Remove symbols`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`subscription.removeSymbols(['AAPL'])
`}</code></pre>
    <h2 {...{
      "id": "get-events-from-stream"
    }}>{`Get events from stream`}</h2>
    <p>{`After an open subscription, you can listen to events from the stream.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const stream = subscription.getStream()

stream.subscribe({
  onSubscribe: sub => {
    sub.request(Number.MAX_SAFE_INTEGER) // set backpressure
  },
  onNext: handleEvents,
})
`}</code></pre>
    <p><inlineCode parentName="p">{`onNext`}</inlineCode>{` its event handler for process incoming events.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import { Quote } from '@dxfeed/widgets-api/records/Quote'

const handleEvents = (events: Quote[]) => {
  /* process events */
}
`}</code></pre>
    <h2 {...{
      "id": "close-subscription-stream"
    }}>{`Close subscription stream`}</h2>
    <p>{`All `}<inlineCode parentName="p">{`onSubscribe`}</inlineCode>{` callbacks that are called with a subscription, you need to call the `}<inlineCode parentName="p">{`subs.close`}</inlineCode>{` method to close the stream.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`stream.subscribe({
  onSubscribe: sub => {
    setTimeout(() => sub.close(), 5000) // close after 5s
  },
  onNext: console.log,
})
`}</code></pre>
    <h2 {...{
      "id": "close-connection"
    }}>{`Close connection`}</h2>
    <p>{`If you need to close the web socket connection`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`client.close()
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      